import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "src/apps/hooks/useAuth";
import { DOCUMENTATION_AREA_ROUTES } from "../Navigation";

interface AlreadyAuthenticatedProps {
  children: ReactNode;
}

export const MissingEmailRedirect = ({ children }: AlreadyAuthenticatedProps) => {
  const { loginEmail } = useAuth();

  if (!loginEmail) {
    return <Navigate to={`${DOCUMENTATION_AREA_ROUTES.LOGIN}${location.search}`} />;
  }

  return <>{children}</>;
};
